import React from "react"

export const MyJobPostsItemSkeleton: React.FC = () => {
  return (
    <>
      <div className="-mt-[1px] flex w-full flex-col gap-x-4 rounded-xl p-8 shadow-[0_4px_24px_0px_rgba(0,0,0,0.1)] md:flex-row md:items-center md:justify-between md:px-0 md:px-6 md:py-6 md:shadow-none">
        <div className="flex h-[72px] flex-row items-center gap-x-6 md:h-[120px]">
          <div className="flex size-[72px] shrink-0 items-center justify-center rounded-md bg-bg-2 md:size-[120px]"></div>
          <div className="flex h-full flex-col justify-center gap-y-2 py-[2px] md:justify-start">
            <div className="rounded my-1 h-4 w-32 bg-bg-2" />
            <div className="rounded h-3 w-24 bg-bg-2" />
          </div>
        </div>
        <div className="h-[129px] md:hidden" />
        <div
          style={{
            boxShadow: "0px 4px 24px 0px rgba(0, 0, 0, 0.10)",
          }}
          className="hidden h-[100px] w-[322px] gap-x-2 rounded-[10px] border border-bg-3 md:flex"></div>
      </div>
    </>
  )
}
